import { CarPickupIcon } from './CarPickupIcon';

/**
 * author: GreenTurtwig
 * id 76BB371D-335C-4F53-A439-2A681778C6BC
 * name car-pickup
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/car-pickup.svg
 * tags
 * - Transportation + Road 
 * - Automotive 
 * - Agriculture 
 */
export const TruckPickupIcon = CarPickupIcon;
export default TruckPickupIcon